import { HighlanderService } from '@1clickfactory/data-access/highlander.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CategorizedRecordingsRequestParams,
  CategorizedRecordingsResponse,
  Recording,
  RecordingListItem,
  RecordingParams,
  RecordingsTopicsPreference,
  RecordingsTopicsPreferenceUpdate,
} from './recordings.model';

@Injectable()
export class RecordingsService {
  private readonly path = (url = ''): string => `recordings/${url}`;

  constructor(private highlanderService: HighlanderService) {}

  getAll(params?: RecordingParams): Observable<RecordingListItem[]> {
    return this.highlanderService.get<RecordingListItem[]>(this.path(), { params });
  }

  getCategorized(params?: CategorizedRecordingsRequestParams): Observable<CategorizedRecordingsResponse[]> {
    return this.highlanderService.get<CategorizedRecordingsResponse[]>(this.path('categorized'), { params });
  }

  getOne(id: string): Observable<Recording> {
    return this.highlanderService.get<Recording>(this.path(`${id}`));
  }

  getTopicsPreferences(): Observable<RecordingsTopicsPreference[]> {
    return this.highlanderService.get<RecordingsTopicsPreference[]>(this.path('topics-preferences'));
  }

  updateTopicsPreferences(topicsPreferences: RecordingsTopicsPreferenceUpdate): Observable<RecordingsTopicsPreference[]> {
    return this.highlanderService.post<RecordingsTopicsPreferenceUpdate, RecordingsTopicsPreference[]>(
      this.path('topics-preferences'),
      topicsPreferences,
    );
  }
}
